import classNames from 'classnames'

import styles from './UpdateOrderPricingModal.module.css'

const messages = {
  confirmation: 'How do you want to update order pricing?',
  confirmationSelected: 'Are you sure you want to update the order pricing?',
  orders: 'Orders: ',
  enqueuedTask:
    "Your orders are updating. You'll receive an email when updates are complete.",
  updateAll: (ordersCount) => (
    <span>
      Update all <var>{ordersCount}</var> orders
    </span>
  ),
  updateSelected: (ordersCount, disabled) => (
    <span className={classNames({ [styles.disabledText]: disabled })}>
      Update only the selected <var>{ordersCount}</var> orders
    </span>
  ),
  primaryButton: 'Update',
  title: 'Update Order Pricing',
}

export default messages
